import { FINAL_CTA } from "@/content/copy";
import CalendlyEmbed from "@/components/site/CalendlyEmbed";

export default function FinalCta() {
  return (
    <section id="book" data-testid="final-cta-section" className="py-20 lg:py-32 bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">{FINAL_CTA.title}</h2>
          <p className="mt-4 text-lg text-white/70 leading-relaxed">{FINAL_CTA.text}</p>
        </div>
        <div className="mt-12 max-w-3xl mx-auto">
          <CalendlyEmbed />
        </div>
      </div>
    </section>
  );
}
